(function () {
    'use strict';
  
    angular
      .module('localization')
      .config(config);
  
    function config($translateProvider) {
  
      var data = {
        'cards': {
          'allCardsOverview': 'All cards',
          'ownerName': '',
          'status': 'Status',
          'cardStatus': 'Card status',
          'dearCustomer': 'Dear customer,',
          'changeLimitInProgress': 'Vaš zahtjev za promjenu limita je u tijeku',
          'activationInProgress': 'Vaš zahtjev za aktivaciju kartice je u tijeku',
          'blockInProgress': 'Vaš zahtjev za blokadu kartice je u tijeku',
          'unblockInProgress': 'Vaš zahtjev za deblokadu kartice je u tijeku',
          'statuses': {
            'Blocked': 'Blocked',
            'SentBlockRequest': '',
            'SentUnblockRequest': '',
            'SentActivationRequest': '',
          },
          'expiryDate': '',
          "nodata": "No availabe data",
          'activation': 'Card activation',
          'block': 'Block card',
          'settings': 'Card settings',
          'settingsSign': 'Postavke kartice - autorizacija',
        'activationSign': 'Aktivacija kartice - autorizacija',

        'temporaryBlock': 'Privremena blokada kartice', 
        'cardBlocked': 'Kartica je blokirana', 
        'cardActive': 'Kartica nije blokirana', 
        
        'onlineShopping': 'Internet kupnja', 
        'enabled': 'Omogućena', 
        'disabled': 'Onemogućena', 

        'dailyLimits': 'Promjene dnevnih limita',
        'POS': 'Kupnja na prodajnim mjestima',
        'ATM': 'Podizanje gotovine na bankomatima',
        'Other': 'Podizanje gotovine na ostalim isplatnim mjestima',
        'change': 'Promijeni',
        'save': 'Potvrdi',
        'cancel': 'Natrag',
        'confirm': 'Potvrdi',
        'acceptChanges': 'Prihvati promjene',
        'dailyLimit': 'Dnevni limit – iznos: ',
        'trnNo': 'Dnevni limit – broj transakcija: ',
        'dailyLimitInfo': 'Povećanjem dnevnih limita za korištenje kartice, povećan je i rizik (iznos potencijalnog gubitka) u slučaju neovlaštenog korištenja kartice zbog krađe kartice ili podataka s kartice.'
        }
      };
  
      $translateProvider
        .translations('en', data);
  
    }
  }());
  